"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.printDuration = exports.Uuid4 = void 0;
__exportStar(require("./commonFunctions"), exports);
__exportStar(require("./lightgallery"), exports);
__exportStar(require("./object"), exports);
__exportStar(require("./offlineLink"), exports);
__exportStar(require("./random"), exports);
__exportStar(require("./supermemo"), exports);
__exportStar(require("./webSocketLink"), exports);
__exportStar(require("./wordsToNumber"), exports);
const uuid4_1 = __importDefault(require("./uuid4"));
exports.Uuid4 = uuid4_1.default;
function printDuration(duration) {
    let timeRemainingMins = Math.floor(duration / 60);
    if (timeRemainingMins < 0) {
        timeRemainingMins = 0;
    }
    const timeRemainingMinsStr = timeRemainingMins >= 10
        ? timeRemainingMins.toString()
        : `0${timeRemainingMins}`;
    let timeRemainingSecs = duration % 60;
    if (timeRemainingSecs < 0) {
        timeRemainingSecs = 0;
    }
    const timeRemainingSecsStr = timeRemainingSecs >= 10
        ? timeRemainingSecs.toString()
        : `0${timeRemainingSecs}`;
    return `${timeRemainingMinsStr}:${timeRemainingSecsStr}`;
}
exports.printDuration = printDuration;
